<template>
  <div class="payPay-content">
    <DownloadApp
      class="down-load-app"
      :text="$t('FoodC_Website_The_WEB_pBbW', { pay_name: 'DidiPay' })"
    />
  </div>
</template>

<script>
import DownloadApp from '@/components/DownloadApp';

export default {
  components: {
    DownloadApp,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.payPay-content {
  margin: 20px auto;
}
.down-load-app {
  margin: 0 24px;
}
@media screen and (max-width: 768px) {
  .down-load-app {
    margin: 0 rem(48);
  }
}
</style>